export default __webpack_public_path__ + "static/media/blog-img105.c271dc73.jpg";